module.exports = __webpack_public_path__ + "16025e15c.png";